export const STATUS = {
  ACTIVE: 'active',
  ERROR: 'danger',
  WARNING: 'warning'
};

export const STATUS_LIST = [STATUS.ACTIVE, STATUS.ERROR, STATUS.WARNING];
